// extracted by mini-css-extract-plugin
export default {"headerArea":"Headers_headerArea__AG7NW","boxTitle":"Headers_boxTitle__0Gc3-"};